/**
 * Determine whether program is currently on air (using start/end timestamps)
 * Show/hide content in the passed `el` if program is on air.
 *
 * — If on air:
 * 1. `hide-from-all` class is removed from the on air element
 * 2. `hide-from-all` class is added to the off air element
 *
 * @param  {Element} el   Element containing both on air/off air content
 * @param  {String} options.offAirSelector  A CSS selector for the public content
 * @param  {String} options.onAirSelector A CSS selector for the authed content
 * @return {Void}
 */

import { parseISO } from "../date";
import isAfter from "date-fns/isAfter";
import isBefore from "date-fns/isBefore";
import isEqual from "date-fns/isEqual";
import { addClass, removeClass } from "../utilities";

export default function onAirToggle(el, props) {
  // Get start and end timestamps
  const startTime = parseISO(props.startTime);
  const endTime = parseISO(props.endTime);

  // Get off air/on air elements
  const offAirEl = el.querySelector(props.offAirEl);
  const onAirEl = el.querySelector(props.onAirEl);
  const upcomingEl = el.querySelector(props.upcomingEl);

  // Guard against executing when the required elements aren't present.
  if (offAirEl == null || onAirEl == null || upcomingEl == null) {
    return;
  }

  // Adjust message if element is live
  const isLive = currentTimeIsBetween(startTime, endTime);
  const isUpcoming = currentTimeBefore(startTime);

  if (isLive) {
    removeClass(onAirEl, "hide-from-all");
    addClass(offAirEl, "hide-from-all");
  } else if (isUpcoming) {
    addClass(offAirEl, "hide-from-all");
    removeClass(upcomingEl, "hide-from-all");
  }

  // Determine if episode is currently on air
  function currentTimeIsBetween(startTime, endTime) {
    const now = new Date();
    return (
      (isBefore(startTime, now) || isEqual(startTime, now)) &&
      isAfter(endTime, now)
    );
  }

  function currentTimeBefore(time) {
    const now = new Date();
    return isBefore(now, time);
  }
}
